import React from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { browserHistory } from "rdx/configureStore";
import { useSession } from "hooks/useSession";
import { generateErrorUID } from "util/generate-error-uid";
import RootFallback from "./Fallbacks/RootFallback";
import { logToAirbrake } from "../../config/airbrake/log-to-airbrake";
import type { ErrorBoundaryProps } from "./types";

type RootBoundaryProps = ErrorBoundaryProps;

export default function RootBoundary({ children }: RootBoundaryProps) {
  const errorUID = generateErrorUID();
  const { session } = useSession();

  const FallbackComponent = (fallbackProps: FallbackProps) => {
    return <RootFallback {...fallbackProps} errorUID={errorUID} />;
  };

  return (
    <ErrorBoundary
      FallbackComponent={FallbackComponent}
      onError={(error, info) => logToAirbrake({ error, info, errorUID, session, browserHistory })}
    >
      {children}
    </ErrorBoundary>
  );
}
